import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction, notEmpty } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { setRebateReasons } from '../ducks/rebateReasons';
import prefix from '../prefix';

const REBATE_REASONS_FETCH = prefix('REBATE_REASONS_FETCH');

export const fetchRebateReasons =
    (): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { container }) => {
        const enterpriseId = getCurrentEnterpriseId();

        const promise = container()
            .orderItemComponent.getRebateReasons({ enterpriseId })
            .then(({ rebateReasons }: { rebateReasons: string[] }) => {
                if (notEmpty(rebateReasons)) {
                    dispatch(setRebateReasons(rebateReasons));
                }
            });

        return dispatch(createFetchAction(REBATE_REASONS_FETCH, promise));
    };
